import {
    addDays,
    addYears,
    endOfDay,
    startOfDay,
    subDays,
    subYears,
} from "date-fns";

export { default as DateShortcutsList } from "./DateShortcutsList.vue";

export const DateShortcut = Object.freeze({
    TODAY: "today",
    YESTERDAY: "yesterday",
    OVERDUE: "overdue",
    NEXT_7_DAYS: "next_7_days",
    LAST_7_DAYS: "last_7_days",
    NEXT_30_DAYS: "next_30_days",
    LAST_30_DAYS: "last_30_days",
    NEXT_12_MONTHS: "next_12_months",
    LAST_12_MONTHS: "last_12_months",
    CUSTOM: "custom",
    EXPIRED: "expired",
});

export const useDateShortcuts = () => {
    const shortcuts = [
        {
            id: DateShortcut.CUSTOM,
            label: "components.inputs.datepicker.shortcuts.custom",
            range: () => {},
        },
        {
            id: DateShortcut.EXPIRED,
            label: "components.inputs.datepicker.shortcuts.expired",
            range: () => {
                const date = new Date();

                return {
                    start: null,
                    end: endOfDay(subDays(date, 1)),
                };
            },
        },
        {
            id: DateShortcut.TODAY,
            label: "components.inputs.datepicker.shortcuts.today",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(date),
                    end: endOfDay(date),
                };
            },
        },
        {
            id: DateShortcut.YESTERDAY,
            label: "components.inputs.datepicker.shortcuts.yesterday",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(subDays(date, 1)),
                    end: endOfDay(subDays(date, 1)),
                };
            },
        },
        {
            id: DateShortcut.OVERDUE,
            label: "components.inputs.datepicker.shortcuts.overdue",
            range: () => {
                const date = new Date();

                return {
                    start: null,
                    end: endOfDay(subDays(date, 1)),
                };
            },
        },
        {
            id: DateShortcut.NEXT_7_DAYS,
            label: "components.inputs.datepicker.shortcuts.next_7_days",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(date),
                    end: endOfDay(addDays(date, 7)),
                };
            },
        },
        {
            id: DateShortcut.LAST_7_DAYS,
            label: "components.inputs.datepicker.shortcuts.last_7_days",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(subDays(date, 7)),
                    end: endOfDay(date),
                };
            },
        },
        {
            id: DateShortcut.NEXT_30_DAYS,
            label: "components.inputs.datepicker.shortcuts.next_30_days",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(date),
                    end: endOfDay(addDays(date, 30)),
                };
            },
        },
        {
            id: DateShortcut.LAST_30_DAYS,
            label: "components.inputs.datepicker.shortcuts.last_30_days",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(subDays(date, 30)),
                    end: endOfDay(date),
                };
            },
        },
        {
            id: DateShortcut.NEXT_12_MONTHS,
            label: "components.inputs.datepicker.shortcuts.next_12_months",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(date),
                    end: endOfDay(addYears(date, 1)),
                };
            },
        },
        {
            id: DateShortcut.LAST_12_MONTHS,
            label: "components.inputs.datepicker.shortcuts.last_12_months",
            range: () => {
                const date = new Date();

                return {
                    start: startOfDay(subYears(date, 1)),
                    end: endOfDay(date),
                };
            },
        },
    ];

    return {
        shortcuts,
    };
};
